// Validate newsletter
const signUpNewsletterBtn = document.querySelectorAll('.signup-form__button');
signUpNewsletterBtn.forEach(button => validateNewsletter(button));

function validateNewsletter(btn) {
   const emailField = btn.parentElement.parentElement.querySelector('.signup-form__email');
   const emailCheckbox = btn.parentElement.parentElement.querySelector('.signup-form__checkbox');
   btn.addEventListener('click', (e) => {
      if(!emailField.value.length || emailCheckbox.checked === false){
         e.preventDefault();

         alert(theme.strings.cart_terms_confirmation);
      }
   })
}

/* TR · Suscripción con nombre, cumpleaños, idioma y origen (oct 2026)
   Añade a los formularios de newsletter (pie, sección y pop-up):
   - nombre (opcional) -> campo nombre del cliente
   - cumpleaños día/mes (opcional) -> etiqueta cumple-MM-DD
   - idioma elegido en el selector de la web -> etiqueta idioma-xx
   - de qué formulario viene -> etiqueta origen-popup / origen-pie / origen-seccion
   Todo queda en la ficha del cliente de Shopify. */
(function () {
  var FORMS = ['footer_newsletter_signup', 'home_newsletter_signup', 'cc-popup'];
  var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function css() {
    if (document.getElementById('tr-signup-css')) return;
    var s = document.createElement('style'); s.id = 'tr-signup-css';
    s.textContent = '.tr-sx{display:flex;flex-direction:column;gap:10px;margin:10px 0;text-align:left}' +
      '.tr-sx fieldset{border:0;margin:0;padding:0;min-width:0}' +
      '.tr-sx legend{font-size:13px;line-height:1.4;color:#5f6472;margin-bottom:6px;padding:0}' +
      '.tr-sx__sel{display:flex;gap:8px}' +
      '.tr-sx select{flex:1;min-width:0}' +
      /* recuadros más finos: 44 px de alto (mínimo cómodo para el dedo), letra 16 px para que el móvil no haga zoom */
      '#footer_newsletter_signup input[type=email],#home_newsletter_signup input[type=email],#cc-popup input[type=email]{height:44px!important;min-height:0!important;padding:0 12px!important;line-height:normal!important;box-sizing:border-box!important}';
    document.head.appendChild(s);
  }

  function idioma() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
      if (m) { var l = decodeURIComponent(m[1]).split('/').pop(); if (/^(ca|es|fr|en)$/.test(l)) return l; }
    } catch (e) {}
    return '';
  }

  var IGUAL = ['height','padding-top','padding-bottom','padding-left','padding-right','border-top','border-right','border-bottom','border-left','border-radius','font-size','font-family','background-color','color','box-sizing'];
  function copiar(email, el) {
    if (!email.offsetHeight) return; // oculto (pop-up cerrado): se copia cuando se vea
    var cs = window.getComputedStyle(email);
    IGUAL.forEach(function (p) { el.style.setProperty(p, cs.getPropertyValue(p)); });
    el.style.width = el.tagName === 'SELECT' ? 'auto' : '100%';
  }
  function sync(form) {
    var email = form.querySelector('input[name="contact[email]"]'); var box = form.querySelector('.tr-sx');
    if (!email || !box) return;
    box.querySelectorAll('input[type=text], select').forEach(function (el) { copiar(email, el); });
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function build(form) {
    if (form.querySelector('.tr-sx')) return;
    var email = form.querySelector('input[name="contact[email]"]');
    if (!email) return;
    var box = document.createElement('div'); box.className = 'tr-sx';
    var nombre = document.createElement('input');
    nombre.type = 'text'; nombre.name = 'contact[first_name]'; nombre.autocomplete = 'given-name';
    nombre.maxLength = 40; nombre.placeholder = 'Tu nombre (opcional)'; nombre.setAttribute('aria-label', 'Tu nombre (opcional)');
    // mismo aspecto que el campo de email del formulario (misma clase y mismas medidas)
    nombre.className = email.className.replace(/\bsignup-form__email\b/, '').trim();
    copiar(email, nombre);
    var fs = document.createElement('fieldset');
    var lg = document.createElement('legend'); lg.textContent = 'Tu cumpleaños (opcional): ese día, un detalle';
    var sel = document.createElement('div'); sel.className = 'tr-sx__sel';
    var dia = document.createElement('select'); dia.setAttribute('aria-label', 'Día'); dia.setAttribute('data-tr-dia', '');
    dia.add(new Option('Día', ''));
    for (var d = 1; d <= 31; d++) dia.add(new Option(String(d), String(d)));
    var mes = document.createElement('select'); mes.setAttribute('aria-label', 'Mes'); mes.setAttribute('data-tr-mes', '');
    mes.add(new Option('Mes', ''));
    MESES.forEach(function (m, i) { mes.add(new Option(m, String(i + 1))); });
    copiar(email, dia); copiar(email, mes); dia.style.width = mes.style.width = 'auto';
    sel.appendChild(dia); sel.appendChild(mes); fs.appendChild(lg); fs.appendChild(sel);
    box.appendChild(nombre); box.appendChild(fs);
    // dentro del pie, el email va dentro de un <p>; en la sección, dentro de un contenedor en línea
    var anchor = email.closest('p, .cc-popup-form__input-wrapper, .signup-form__inline-container') || email;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    // Pop-up (3-10-2026, decisión de Hiro): un solo paso. Email, nombre y cumpleaños a la vista desde el principio
    // (nombre y cumpleaños marcados como opcionales). Nada de campos que aparecen después de escribir el email.
    // Texto corto en el email del pop-up: el largo («Tu dirección de correo electrónico») se cortaba en el móvil.
    if (form.id === 'cc-popup') { email.placeholder = 'Tu email'; email.setAttribute('aria-label', 'Tu email'); }
  }

  function init() {
    css();
    FORMS.forEach(function (id) { var f = document.getElementById(id); if (f) { build(f); sync(f); } });
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || FORMS.indexOf(f.id) === -1) return;
    var tags = f.querySelector('input[name="contact[tags]"]'); if (!tags) return;
    var base = tags.getAttribute('data-tr-base') || tags.value; tags.setAttribute('data-tr-base', base);
    var extra = [];
    var ORIGEN = { 'cc-popup': 'origen-popup', 'footer_newsletter_signup': 'origen-pie', 'home_newsletter_signup': 'origen-seccion' };
    if (ORIGEN[f.id]) extra.push(ORIGEN[f.id]);
    var l = idioma(); if (l) extra.push('idioma-' + l);
    var dia = f.querySelector('[data-tr-dia]'), mes = f.querySelector('[data-tr-mes]');
    if (dia && mes) {
      var d = parseInt(dia.value, 10), m = parseInt(mes.value, 10);
      var max = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (d && m && d <= max[m - 1]) extra.push('cumple-' + pad(m) + '-' + pad(d));
    }
    var n = f.querySelector('input[name="contact[first_name]"]');
    if (n) n.value = (n.value.trim().split(/\s+/)[0] || '').slice(0, 40);
    tags.value = base + (extra.length ? ',' + extra.join(',') : '');
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // el pop-up se pinta más tarde: reintento suave
  setTimeout(init, 3000); setTimeout(init, 8000); setTimeout(init, 27000);
  // cuando se abre el pop-up o se enfoca un formulario, igualar medidas
  document.addEventListener('focusin', function (e) { var f = e.target.form; if (f && FORMS.indexOf(f.id) !== -1) sync(f); });
  if (window.MutationObserver) { var pop = document.querySelector('.cc-popup'); if (pop) new MutationObserver(function () { var f = document.getElementById('cc-popup'); if (f) sync(f); }).observe(pop, { attributes: true, attributeFilter: ['class', 'style'] }); }
})();
